import axios from "axios";
import { host } from "../../helper/config";
import { getItemPerPage } from "../../helper/helper";

const PLUGINS_NAME = "admin-charge";

// GET LIST CHARGE
export const getListCharge = async (token, query, page, endPointId) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/get-list-charge`,
    {
      ...query,
      page: page,
      itemPerPage: getItemPerPage(),
      endPointId: endPointId,
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

export const getSummaryCharge = async (token, query, endPointId) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/get-summary-charge`,
    {
      ...query,
      endPointId: endPointId,
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return null;
};

export const getListRefund = async (token, query, page, endPointId) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/get-list-refund`,
    {
      ...query,
      page: page,
      itemPerPage: getItemPerPage(),
      endPointId: endPointId,
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

export const getSummaryRefund = async (token, query, endPointId) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/get-summary-refund`,
    {
      ...query,
      endPointId: endPointId,
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return null;
};

// ADD CHARGE
export const addCharge = async (
  token,
  chargeValue,
  chargeMethod,
  accountId,
  phone,
  referenceNumber
) => {
  try {
    console.log("addCharge request:", {
      chargeValue,
      chargeMethod,
      accountId,
      userId: phone,
      referenceNumber:
        referenceNumber.trim() === ""
          ? new Date().getTime().toString()
          : referenceNumber,
    });

    const response = await axios.post(
      `${host}/${PLUGINS_NAME}/add-charge`,
      {
        chargeValue: chargeValue,
        chargeMethod: chargeMethod,
        accountId: accountId,
        userId: phone,
        referenceNumber:
          referenceNumber.trim() === ""
            ? new Date().getTime().toString()
            : referenceNumber,
      },
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    console.log("addCharge response:", response.status, response.data);

    if (response && response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    console.error("addCharge error:", error);

    if (error.response) {
      // Server responded with error status
      console.error("Error response:", {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers,
      });

      // Return error info for better handling
      return {
        error: true,
        status: error.response.status,
        message: error.response.data?.message || "Server error",
        data: error.response.data,
      };
    } else if (error.request) {
      // Network error
      console.error("Network error:", error.request);
      return {
        error: true,
        status: 0,
        message: "Network error - cannot connect to server",
      };
    } else {
      // Other error
      console.error("Request setup error:", error.message);
      return {
        error: true,
        status: -1,
        message: error.message,
      };
    }
  }
};

export const getListIssueCharge = async (token, query, page) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/get-list-charge-issue`,
    {
      ...query,
      page: page,
      itemPerPage: getItemPerPage(),
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

export const deleteIssueCharge = async (token, id) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/delete-charge-issue`,
    {
      id: id,
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};
